declare global {
    interface Window {
        dataLayer: Record<string, any>[];
    }
}

export class FormTracker {
    private readonly selectors: string[];

    constructor(selectors: string[]) {
        this.selectors = selectors;
        this.ensureDataLayer();
        this.registerForms();
    }

    private ensureDataLayer() {
        if (!window.dataLayer) {
            window.dataLayer = [];
        }
    }

    private registerForms() {
        const selector = this.selectors.join(",");
        const forms = document.querySelectorAll<HTMLFormElement>(selector);
        console.debug("Register forms. Found: " + forms.length);
        forms.forEach((form) => {
            form.addEventListener("focusin", () => this.pushEvent("form_start"), {
                once: true
            });
            form.addEventListener("submit", () => this.pushEvent("form_submit"));
        });
    }

    private pushEvent(eventName: string) {
        window.dataLayer.push({ event: eventName });
        console.debug("FormTracker: dataLayer push", { event: eventName });
    }
}
